import { me, login as apiLogin, register as apiRegister, redeem as apiRedeem } from '../../api';

// 登录态 + 用户信息（到期时间/用量）。token 存 localStorage
export default {
  namespaced: true,
  state: () => ({
    token: localStorage.getItem('token') || '',
    user: null, // {id,name,phone,expireAt,tokenQuota,tokenUsed,expired}
    ready: false,
  }),
  getters: {
    loggedIn: (s) => !!s.token,
    expired: (s) => !!(s.user && s.user.expired),
  },
  mutations: {
    setToken(s, t) { s.token = t || ''; if (t) localStorage.setItem('token', t); else localStorage.removeItem('token'); },
    setUser(s, u) { s.user = u; },
    setReady(s, v) { s.ready = v; },
    patchUser(s, u) { if (s.user && u) s.user = { ...s.user, ...u }; },
  },
  actions: {
    // 启动时恢复会话
    async init({ state, commit }) {
      if (!state.token) { commit('setReady', true); return; }
      try { commit('setUser', await me()); } catch { commit('setToken', ''); }
      commit('setReady', true);
    },
    async login({ commit }, payload) {
      const d = await apiLogin(payload);
      commit('setToken', d.token); commit('setUser', d.user);
      return d.user;
    },
    async register({ commit }, payload) {
      const d = await apiRegister(payload);
      commit('setToken', d.token); commit('setUser', d.user);
      return d.user;
    },
    async refresh({ commit }) {
      commit('setUser', await me());
    },
    async redeem({ dispatch }, code) {
      const d = await apiRedeem(code);
      dispatch('refresh');
      return d;
    },
    logout({ commit }) { commit('setToken', ''); commit('setUser', null); },
  },
};
